/* global jQuery */
// Simple callback bases AJAX function. Uses mtt.ajax_url
function mttSimpleAjax(data, callback){
    jQuery.ajax({
        method: 'POST',
        url: window.main_theme_objects.ajax_url,
        data: data,
    }).done(callback).fail(callback);
}

if(typeof window.mtt_ajax === 'undefined'){
    window.mtt_ajax = {}; // This object will keep track of ajax status
}

// Callback bases AJAX function. Uses mtt.ajax_url
// Only one request with the same ajax_id can be active at a time
function mttAjax(ajax_id, data, callback){
    if(typeof window.mtt_ajax[ajax_id] === "undefined"){
        window.mtt_ajax[ajax_id] = null; // If no req uest have been made yet using this ajax_id, then set default
    }
    window.mtt_ajax[ajax_id] = jQuery.ajax({
        method: 'POST',
        url: window.main_theme_objects.ajax_url,
        data: data,
        beforeSend: () => {
            if(window.mtt_ajax[ajax_id] != null){
                window.mtt_ajax[ajax_id].abort();
            }
        },
    }).done(callback).fail(callback);
}

export { mttSimpleAjax,mttAjax };